import styled from "styled-components";

export const BoardWrapper = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`;

export const BoardContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(224px, 1fr));
  background-color: #f8f8ff;
  border-radius: 12px;
`;

export const BoardValue = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 16px;

  span {
    min-width: 136px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 500;
    color: #888888;

    i {
      min-width: 28px;
    }
  }

  p {
    position: relative;
    line-height: 28px;
    font-size: 22px;
    font-weight: bold;
    color: #15192c;
    margin: 0;
    padding-left: 2px;

    i {
      position: absolute;
      top: -2px;
      margin-left: 2px;
    }
  }
`;
